import * as yup from 'yup';


const companyDetailsSchema = yup.object({
  type: yup
    .string('Type')
    .required('Type is required'),
  companyRegisteredName: yup
    .string('Company registered name')
    .required('Company registered name is required')
    .min(3,"Company name minimum 3 characters")
    .max(35,"Company name maximum 35 characters")
  ,
  registrationNumber: yup
    .string('Registration number')
    .required('Registration number is required')
    .min(4,'Registration number must be of 4 characters')
  ,
  registeredAddress: yup
    .string('Registration address')
    .required('Registration address is required')
      .min(3,"Company address minimum 3 characters")
      .max(35,"Company address maximum 35 characters")
  ,

  taxIdentifier: yup
    .string('Tax identifier')
    .required('Tax identifier is required'),
});


const initialValues = {
  type: '',
  companyRegisteredName: '',
  registrationNumber: '',
  registeredAddress: '',
  taxIdentifier: '',
}


const CompanyDetailsValidation = {initialValues, companyDetailsSchema}
export default CompanyDetailsValidation;